export default __webpack_public_path__ + "static/media/login_banner.cd891b8c.png";